export type OnboardingMode = "site-projects" | "single-project";

export type OnboardingProfile =
	| "construction-company"
	| "independent-pro"
	| "self-build"
	| "renovation";

export type OnboardingStepId =
	| "account"
	| "profile"
	| "mode"
	| "structure"
	| "team"
	| "summary";

export interface AccountData {
	name: string;
	email: string;
}

export interface ProfileData {
	type: OnboardingProfile;
	companyName: string | null;
}

export type SiteStatus = "active" | "paused";

// OnboardingAddress is the structured postal address captured by the wizard.
// number/complement may be empty; lat/lng are populated by CEP lookup or the
// map pin.
export interface OnboardingAddress {
	street: string;
	number: string;
	complement: string;
	neighborhood: string;
	city: string;
	state: string;
	zipcode: string;
	lat?: number;
	lng?: number;
}

export function emptyOnboardingAddress(): OnboardingAddress {
	return {
		street: "",
		number: "",
		complement: "",
		neighborhood: "",
		city: "",
		state: "",
		zipcode: "",
	};
}

// isOnboardingAddressComplete mirrors the API's required-address contract so the
// "continue" button stays in sync with what the backend will accept.
export function isOnboardingAddressComplete(a: OnboardingAddress): boolean {
	return (
		a.street.trim() !== "" &&
		a.number.trim() !== "" &&
		a.neighborhood.trim() !== "" &&
		a.city.trim() !== "" &&
		a.state.trim() !== "" &&
		a.zipcode.trim() !== ""
	);
}

export interface SiteData {
	name: string;
	address: OnboardingAddress;
	area: string;
	status: SiteStatus;
}

export interface ProjectDraft {
	id: string;
	name: string;
	type: string;
	budget: string;
	startDate: string;
	forecastEnd: string;
	color: string;
	address: OnboardingAddress;
}

export type TeamRole = "engineer" | "almoxarife" | "funcionario" | "cliente";

export interface InviteDraft {
	id: string;
	email: string;
	role: TeamRole;
}
